import { render, staticRenderFns } from "./JNewLabel.vue?vue&type=template&id=0b123b89&scoped=true&"
import script from "./JNewLabel.vue?vue&type=script&lang=js&"
export * from "./JNewLabel.vue?vue&type=script&lang=js&"
import style0 from "./JNewLabel.vue?vue&type=style&index=0&id=0b123b89&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b123b89",
  null
  
)

export default component.exports